<template>
  <div>
    <vs-table stripe pagination max-items="5" search :data="users">
      <template slot="header">
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          @click="add"
          >Agregar</vs-button
        >
      </template>
      <template slot="thead">
        <vs-th>Nombre</vs-th>
        <vs-th class="w-1/3">Menus</vs-th>
        <vs-th>Estado</vs-th>
        <vs-th class="grid justify-items-center">
          <div class="text-center">Acciones</div>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.roleName">
            {{ tr.roleName }}
          </vs-td>

          <vs-td :data="tr.menu">
            <vs-chip v-for="(item, index) in tr.menu" :key="index" color="warning">{{
              item.men_name
            }}</vs-chip>
          </vs-td>

          <vs-td :data="tr.roleStatus">
            <vs-chip v-if="tr.roleStatus == 1" color="primary">Activo</vs-chip>
            <vs-chip v-else color="danger">Off</vs-chip>
          </vs-td>

          <vs-td class="">
            <div class="grid grid-cols-2 justify-items-center">
              <vs-button
                radius
                color="warning"
                type="flat"
                icon-pack="feather"
                icon="icon-edit"
                @click="edit(tr)"
              ></vs-button>
              <!-- <vs-button
                radius
                color="danger"
                type="flat"
                icon-pack="feather"
                icon="icon-trash"
                @click="trash(tr)"
              ></vs-button> -->
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    users() {
      return this.$store.state.lists.table_rol;
    },
    menus() {
      return this.$store.state.lists.table_menu;
    },
  },
  mounted() {
    this.$store.dispatch("lists/getListRol");
  },
  methods: {
    add() {
      let display = {
        table: false,
        add: true,
        edit: false,
      };
      this.$emit("screen", display);
      this.$store.commit("rol/trash_rol");
    },
    edit(item) {
      this.$store.commit("rol/rolId", item.roleId);
      this.$store.commit("rol/name", item.roleName);
      this.$store.commit("rol/rols", item.menu);
      this.$store.commit("rol/guard_name", item.guardName);
      this.$store.commit("rol/rol_status", item.roleStatus);
      let display = {
        table: false,
        add: false,
        edit: true,
      };
      this.$emit("screen", display);
    },
    trash(item) {
      console.log(item);
    },
  },
};
</script>
